export const fullscreenchange = "fullscreenchange";
export const webkitfullscreenchange = "webkitfullscreenchange";
